import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, Radio, TextField, Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions/index.js';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER, SERVER_URL } from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category,  } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import { Box, FormControl, FormControlLabel, FormLabel, RadioGroup } from "@mui/material";
import Dropzone from "react-dropzone";
import uploadIcon from '../../assets/img/profile-upload-icon.png'
import { NotificationManager } from "react-notifications";
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";
import AreYouSureAlert from "../../components/Alert/AreYouSureAlert.jsx";
import { getCookies } from "../../utils/getToken.js";
import Axios from "axios";

let isMounted = false;

class BookingApprovalScreenNew extends Component {
    constructor(props) {
        super(props);

        this.state = { 
            update: false, 
            showAlert: false,
            feedback: '',
            maxRating: [1, 2, 3, 4, 5],
            isRed: false,
            isYellow: false,
            isGreen: false,
            bookingData: this.props.history.location.state.bookingData,
        }
    }
    componentDidMount() {
        console.log("APPROVAL SCREEN bookingData", this.state.bookingData);
    }

    componentWillUnmount() {
    }

    renderLoading = index => {
        return (
            <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    borderRadius={5}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>
        );
    };

    onAcceptBookingPressed = async() => {
        
        var authToken = getCookies();
        console.log('AUTH TOKEN', authToken);
        this.setState({
          showAlert: false
        })
        try {
          const {data} = await Axios({
            method: 'post', //you can set what request you want to be
            url: `${SERVER_URL}/booking/user-approve`,
            data: {
                booking_id: this.state.bookingData.id,
                booking_closure_rating:this.state.defaultRating,
                booking_closure_feedback:this.state.feedback,
                status: this.state.bookingData.status
            },
            headers: {
              'x-auth-Token': authToken,
            },
          });
          console.log('APPROVAL DATA', data);
          if (data.status == 'OK') {
            this.setState({
              loading:false
            })
            NotificationManager.success(data.message, 'Success');
            this.props.history.push('/user/manage_bookings')
          }
          else{
            this.setState({
              loading:false
            })
            NotificationManager.error(data.message, 'Error');
            this.props.history.push('/user/manage_bookings')
            // alertError(this,data.message)
            // this.props.navigation.navigate('HomeScreen');
          }
        } catch (error) {
          console.log("=========================================================APPROVAL ERRORRRRRR",error);
        }

        // this.props.history.push('/user/confirm_booking',{
        //     bookingDetails: this.state.taskDetailsPrev, 
        //     bookingInfoData: this.state.bookingInfoDataPrev,
        //     aditionalData : aditionalData
        // })
    }

    onRatingPress = rating => {
        this.setState({
          defaultRating: rating,
        });
        console.log('default RATE --->', rating, this.state.defaultRating);

        if (rating <= 2) {
            this.setState({
              isRed: true,
              isYellow: false,
              isGreen: false,
            });
          } else if (rating <= 4) {
            this.setState({
              isRed: false,
              isYellow: true,
              isGreen: false,
            });
          } else {
            this.setState({
              isRed: false,
              isYellow: false,
              isGreen: true,
            });
          }
      }
    
       ratingsEmpty= {
        // backgroundColor: 'green',
        border: '1px solid #0078ff',
        margin: 5,
        // marginVertical: 20,
        margin: 25,
        padding: '20px',
        paddingLeft: '30px',
        paddingRight: '30px',
        // paddingHorizontal: 19,
        borderRadius: 100,
        color: '#0078ff',
        // color: 'white',
        textAlign: 'center',
        fontWeight: '700',
        fontSize: 20,
    }

     ratingGivenGreen= {
        backgroundColor: 'green',
        border: '1px solid green',
        margin: 5,
        // marginVertical: 20,
        margin: 25,
        padding: '20px',
        paddingLeft: '30px',
        paddingRight: '30px',
        borderRadius: 100,
        // color: 'green',
        color: 'white',
        textAlign: 'center',
        fontWeight: '700',
        fontSize: 20,
    }
     ratingGivenRed= {
        backgroundColor: 'red',
        border: '1px solid red',
        margin: 5,
        // marginVertical: 20,
        margin: 25,
        padding: '20px',
        paddingLeft: '30px',
        paddingRight: '30px',
        borderRadius: 100,
        // color: 'green',
        color: 'white',
        textAlign: 'center',
        fontWeight: '700',
        fontSize: 20,
    }
     ratingGivenYellow= {
        backgroundColor: 'orange',
        border: '1px solid orange',
        margin: 5,
        // marginVertical: 20,
        margin: 25,
        padding: '20px',
        paddingLeft: '30px',
        paddingRight: '30px',
        borderRadius: 100,
        // color: 'green',
        color: 'white',
        textAlign: 'center',
        fontWeight: '700',
        fontSize: 20,
    }

    getRatingsStyle = (i) => {
        console.log('i', i);
        // i <= this.state.defaultRating && i <= 2 && this.state.isRed
                    // ? ratingGivenRed
                    // : i <= this.state.defaultRating && i <= 4 && this.state.isYellow
                    // ? ratingGivenYellow
                    // : i <= this.state.defaultRating && i <= 5 && this.state.isGreen
                    // ? ratingGivenGreen
                    // : ratingsEmpty,

        if(i <= this.state.defaultRating && i <= 2 && this.state.isRed){
            return this.ratingGivenRed
        } else if(i <= this.state.defaultRating && i <= 4 && this.state.isYellow){
            return this.ratingGivenYellow
        } else if(i <= this.state.defaultRating && i <= 5 && this.state.isGreen){
            return this.ratingGivenGreen
        } else {
            return this.ratingsEmpty
        }
    }

    renderRatings = i => {

        return (
          <div>
            <p
              style={this.getRatingsStyle(i)
                // [
                //   i <= this.state.defaultRating && i <= 2 && this.state.isRed
                //     ? ratingGivenRed
                //     : i <= this.state.defaultRating && i <= 4 && this.state.isYellow
                //     ? ratingGivenYellow
                //     : i <= this.state.defaultRating && i <= 5 && this.state.isGreen
                //     ? ratingGivenGreen
                //     : ratingsEmpty,
                // ]
                // ,
                //   [
                //     i <= this.state.defaultRating && i <= 4
                //     ? styles.ratingGivenYellow
                //     : styles.ratingsEmpty
                //   ]
              }>
              {i}
            </p>
          </div>
        );
      };

    render() {
        var well={
            boxShadow: "2px 1px 5px #ddd",
            backgroundColor: '#fff',
            padding: 10,
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            // textAlign: 'center',
            cursor: 'pointer',
            borderRadius: 5
        }

        return (
            <div className="tz-2-com tz-2-main h4-padding">
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <NavbarNew
                                title='Booking Approval' 
                                goback={() => this.props.history.goBack(null)} 
                            />
                            <div style={{
                                boxShadow: "1px 1px 20px #ddd",
                                padding: 20,
                                borderRadius: 5,
                                margin: '20px 0 40px 0'
                            }}>
                                <div>
                                    <p style={{
                                        fontSize: 17,
                                        fontWeight: 'bold',
                                    }}>Rate the work done</p>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',}}
                                    >
                                        {this.state.maxRating.map(i => {
                                            return (
                                            <p
                                                key={i}
                                                onClick={() => this.onRatingPress(i)}
                                                style={{marginTop: 10}}>
                                                {/* <Text 
                                                    // style={[styles.ratingsEmpty]}
                                                    style={[i <= this.state.defaultRating ? styles.ratingGiven : styles.ratingsEmpty]}
                                                    >
                                                    {i}
                                                    </Text> */}
                                                {this.renderRatings(i)}
                                            </p>
                                            );
                                        })}
                                    </div>
                                    <p style={{fontSize: 18, textAlign: 'center'}}>
                                        {
                                            this.state.defaultRating > 0
                                            ? `You rated - ${this.state.defaultRating}`
                                            : null
                                        }
                                    </p>
                                </div>
                                <div>
                                    <p style={{
                                        fontSize: 17,
                                        fontWeight: 'bold',
                                    }}>Feedback (if any)</p>
                                    <textarea
                                        // id="required"
                                        // className="border-0 form-control chat-textarea"
                                        // onKeyUp={this._handleKeyPress.bind(this)}
                                        onChange={(e) => this.setState({
                                            feedback: e.target.value
                                        })}
                                        value={this.state.feedback}
                                        placeholder="Write your feedback here"
                                        style={{
                                            height: '20vh',
                                            borderRadius: '10px',
                                            // marginBottom: 20
                                        }}
                                    />
                                </div>
                            </div>
                            
                            <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    marginTop: 20
                                }}>
                                    <p 
                                    onClick={()=> {
                                        console.log("rating, feedback",this.state.defaultRating, this.state.feedback);
                                        this.setState({showAlert: true})
                                    }}
                                    style={{
                                        backgroundColor: '#0078ff',
                                        padding: 10,
                                        color: '#fff',
                                        borderRadius: 5,
                                        fontSize: 17,
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }}>Accept Booking Completion</p>
                            </div>
                        </div>
                    </div>
                </div>
                <AreYouSureAlert
                    open={this.state.showAlert}
                    title=""
                    content="By accepting this you acknowledge the work was completed to your satisfaction. Thank you! Our Pros do stand by their work for 30 days should you have any issues. Do you want to continue?"
                    close={() => this.setState({ showAlert: false })}
                    handleYes={this.onAcceptBookingPressed}
                    handleNo={() => this.setState({ showAlert: false })}
                />
            </div>
        );
    }
}


const mapStateToProps = ({ settings, categories, providers, auth }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader,
        userData: auth.userData,

    };
};
const composedProfile = compose(connect(mapStateToProps, actions));
export default composedProfile(withRouter(BookingApprovalScreenNew));



// WEBPACK FOOTER //
// ./src/views/User/BookingApprovalScreenNew.jsx